module.exports = __webpack_public_path__ + "img/A-Yeasts.d5783270.png";